import React, { useEffect } from 'react';
import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Box,
} from '@mui/material';
import { useSessionData } from '../../auth/SessionDataProvider';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';

export default function GameModeSelectorCompact({ fullWidth = true, size = "medium", sx = {}, onChange }) {
    const { data, setData, setGameMode } = useSessionData();
    const gameModes = (data?.gameModes || []).filter(mode => mode.visible === 1);
    const selected = data.gameMode ?? '';

    useEffect(() => {
        if (!selected && gameModes.length) {
            const defaultId = gameModes[0].id;
            setGameMode(defaultId);
        }
    }, [gameModes, selected, setGameMode]);

    const handleChange = (event) => {
        const newId = event.target.value;
        setGameMode(newId);

        if (onChange) {
            onChange(newId);
        }
    };

    return (
        <Box display="flex" alignItems="center" gap={1} sx={{ ...sx, minWidth: fullWidth ? '150px' : 'auto' }}>
            <FormControl fullWidth={fullWidth} size={size}>
                <InputLabel
                    id="game-mode-select-label"
                    sx={{
                        mt: 2,
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#b4a0eb',
                        '&.Mui-focused': { color: '#b4a0eb' }
                    }}
                >
                    <SportsEsportsIcon sx={{ color: '#ffe066', mr: 1 }} /> Game Mode
                </InputLabel>
                <Select
                    variant="filled"
                    labelId="game-mode-select-label"
                    value={selected}
                    label="Select Game Mode"
                    onChange={handleChange}
                    sx={{
                        color: '#fff',
                        backgroundColor: '#2a2e3d',
                        borderRadius: 2,
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#7a52e0'
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#b4a0eb'
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#fff'
                        }
                    }}
                >
                    {gameModes.map((mode) => (
                        <MenuItem key={mode.id} value={mode.id}>
                            {mode.title}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
